import { useEffect } from 'react';

import { useTabsUBL } from '../log/useTabsUBL';

export const useSizeInfoTabImpressionLogSend = (
  isShowSizeTab: boolean,
  isApp: boolean,
  catalog_product_id: string,
  isRevealed: boolean,
) => {
  const { impressionSizeInfoTabUBL } = useTabsUBL();

  useEffect(() => {
    if (!isRevealed || !isShowSizeTab) {
      return;
    }

    impressionSizeInfoTabUBL(isApp, catalog_product_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRevealed, isShowSizeTab]);
};
